
import BScroll from "better-scroll";
import Qrcode from 'vux/src/components/qrcode/index.vue'

import Cookies from "js-cookie";
export default {
components: {
Qrcode
},
data() {
return {
dzzhao: "",
bscroll: ""
};
},
mounted() {
this.initScroll();
this.dzzhao = Cookies.get("dzzhao");
},
methods: {
initScroll() {
let wrapper = document.querySelector(".p-e_card");
if (!this.bscroll) {
this.bscroll = new BScroll(wrapper, {
click: true,
bounce: {
top: false,
bottom: false,
left: false,
right: false
}
});
} else {
this.bscroll.refresh();
}
}
}
};
